<template>
	<DatePicker
		:disabled="disabled"
		v-model="date"
		@update:model-value="dateChanged"
		week-numbers
		week-num-name="U"
		locale="da"
		:format="format"
		:day-names="['Ma', 'Ti', 'On', 'To', 'Fr', 'Lø', 'Sø']"
		:auto-apply="true"
		:close-on-auto-apply="enableTime ? false : true"
		:enable-time-picker="enableTime"
		:text-input="{
			format: ['ddMMyyyy', 'dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy'],
		}"
		ref="datepicker"
		:disabled-dates="disableAfterToday"
	>
		<template #dp-input="{ value, onInput, onEnter, onTab, onBlur }">
			<input
				:disabled="disabled"
				class="form-control"
				:style="disabled ? { backgroundColor: 'white' } : ''"
				type="text"
				:value="value"
				@blur="onBlur"
				@keydown.enter="onEnter"
				@keydown.tab="onTab"
				@input="onInput"
			/>
		</template>
		<template #input-icon>
			<span class="input-group-text">
				<font-awesome-icon
					icon="calendar-check"
					height="1rem"
					class="d-flex"
				/>
			</span>
		</template>
		<template #clear-icon />
	</DatePicker>
</template>

<script setup>
import { onMounted, ref } from "vue";

import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import "@oldSrc/assets/datepicker.css";

const props = defineProps({
	noDate: {
		type: Boolean,
		default: false,
	},
	disabled: Boolean,
	disableFutureDates: {
		type: Boolean,
		default: false,
	},
	disablePastDates: {
		type: Boolean,
		default: false,
	},
	enableTime: {
		type: Boolean,
		default: false,
	}
});
const datepicker = ref(null);

const startDate = new Date();
const date = ref(startDate);
const format = ref("dd.MM.yyyy");

date.value = !props.noDate ? startDate : null;

const emit = defineEmits(["change"]);

const dateChanged = () => {
	emit("change", date);
};

const clearDate = () => {
	datepicker.value.clearValue();
};

const setDate = (selectedDate) => {
	date.value = selectedDate;
};

const disableAfterToday = (date) => {
	const today = new Date();
	if 		(props.disableFutureDates)	return date > today;
	else if (props.disablePastDates)	return date < today;
	else								return null;
}

onMounted(() => {
	if (!props.noDate) emit("change", date);
	if (props.enableTime) format.value = "dd.MM.yyyy HH:mm"
});

defineExpose({ clearDate, setDate });
</script>
